import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  fetching: PropTypes.bool.isRequired,
  success: PropTypes.bool.isRequired,
  children: PropTypes.func.isRequired,
};

class AsyncStatus extends React.Component {
  state = { show: false, error: false };
  timeout = null;
  mounted = false;

  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }

  componentDidUpdate(oldProps) {
    const newProps = this.props;
    if (!(newProps.fetching === true && oldProps.fetching === false)) {
      return;
    }
    if (newProps.success === false && oldProps.success === true) {
      clearTimeout(this.timeout);
      this.setState({ show: true, error: false });
      this.timeout = setTimeout(this.clear, 3000);
    } else {
      this.setState({ show: true, error: true });
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.clear, 3000);
    }
  }

  clear = () => {
    if (this.mounted === false) return;
    this.setState({ show: false, error: false });
  };

  render() {
    const { fetching, children } = this.props;
    const status = { fetching: false, failure: false, success: false };

    if (this.state.show) {
      status.success = true;
    }

    if (this.state.error) {
      status.success = false;
      status.failure = true;
    }
    if (fetching) {
      status.success = false;
      status.failure = false;
      status.fetching = true;
    }

    return children(status);
  }
}

AsyncStatus.propTypes = propTypes;
export default AsyncStatus;



// WEBPACK FOOTER //
// ./src/components/ui/AsyncStatus.jsx